






















import { Component, Prop, Vue } from 'vue-property-decorator';
import FormHeader from '../headers/form-header/form-header.vue';

import AdminTabPark from '../admin/admin-tab-parks/adminTabPark.vue';
import AdminTabUsers from '../admin/admin-tab-user/adminTabUser.vue';
import AdminTabBookings from '../admin/admin-tab-booking/adminTabBooking.vue';

import { IPark } from '@/models/IPark.model';

const ADMIN_PASSWORD = '33DFX';

@Component({
    components: {
        'form-header': FormHeader,
        'admin-tab-parks': AdminTabPark,
        'admin-tab-users': AdminTabUsers,
        'admin-tab-bookings': AdminTabBookings,
    },
})
export default class AdminAuthView extends Vue {

  public mdInputText = '';
  public mdFieldClass = '';

  @Prop()
  parks!:IPark[];


  onSubmit(){
   if(this.mdInputText === ADMIN_PASSWORD ){
       localStorage.setItem('isAuth','true')
    this.$emit('onSucceed');
    } else {
        this.$emit('onFailed');
    }
  }
  

}
